import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import ValidatedImage from "../../../utils/ValidatedImage";
import { makeStyles } from "@material-ui/core/styles";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

const useStyles = makeStyles(() => ({
  dialogTitle: {
    fontFamily: "Open Sans",
    fontWeight: 600,
    fontSize: "16px",
    color: "#0b1f82",
    padding: "16px 24px 0px 24px",
  },
  dialogContent: {
    textAlign: "center",
    marginBottom: "10px",
    float: "left",
  },
  arrows: {
    color: "#0b1f82",
  },
  buttonPrevious: {
    cursor: "pointer",
    width: "25%",
    borderRadius: "10px",
    "&:hover": {
      backgroundColor: "#ddddf9",
    },
  },
}));

function OthersDialog({ open, onClose, image_list, fileType }) {
  const classes = useStyles();
  const [counter, setCounter] = useState(0);

  const imageListFiltered = image_list.filter(image => image != null);

  const clickNext = () => {
    setCounter((counter + 1) % imageListFiltered.length);
  };

  const clickPrevious = () => {
    setCounter((counter - 1 + imageListFiltered.length) % imageListFiltered.length);
  };

  return (
    <Dialog open={open} onClose={onClose} keepMounted={false} fullWidth maxWidth="lg">
      <DialogTitle className={classes.dialogTitle}>Fotos</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <div style={{ display: "flex", margin: "auto", justifyContent: "center" }}>
          <div className="labelSpace" style={{ order: 2, display: "flex" }}>
            {imageListFiltered[counter] ? (
              <ValidatedImage
                image_key={imageListFiltered[counter]}
                dash_api_endpoint_url="/dash/ocr/image"
                imageStyle={{ maxWidth: "100px", maxHeight: "100px", borderRadius: "5px" }}
                imageAlt="Foto do Documento"
                zoom_enabled
                fileType={fileType}
              />
            ) : (
              <div
                className={["labelText", "normalMediumSize"].join(" ")}
                style={{ textAlign: "center", margin: "auto" }}
              >
                Informação Indisponível
              </div>
            )}
          </div>
          {imageListFiltered.length > 1 && (
            <>
              <div onClick={clickPrevious} className={classes.buttonPrevious} style={{ order: 1, display: "flex" }}>
                <ArrowBackIosIcon style={{ margin: "auto" }} className={classes.arrows} />
              </div>
              <div onClick={clickNext} className={classes.buttonPrevious} style={{ order: 3, display: "flex", marginLeft: "5px" }}>
                <ArrowForwardIosIcon style={{ margin: "auto" }} className={classes.arrows} />
              </div>
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default OthersDialog;
